export enum ModelAsset {
  PalletStackerCraneGroundRail = "pallet-stacker-crane-ground-rail",
  PalletStackerCraneBase = "pallet-stacker-crane-base",
  PalletStackerCranePost = "pallet-stacker-crane-post",
  PalletStackerCraneTop = "pallet-stacker-crane-top",
  PalletStackerCraneSkyRail = "pallet-stacker-crane-sky-rail",
  PalletStackerCraneCarriage = "pallet-stacker-crane-carriage",
  PalletStackerCraneControlCabinet = "pallet-stacker-crane-control-cabinet",
  AngleIron = "angle-iron",
  BasePlate = "base-plate",
  BinRackBrace = "bin-rack-brace",
  BinCargo = "bin-cargo",
  BinRackCrossbar = "bin-rack-crossbar",
  BinRackPanel = "bin-rack-panel",
  BinRackPost = "bin-rack-post",
  Crossbar = "crossbar",
  DoubleChainConveyorCrossbar = "double-chain-conveyor-crossbar",
  DoubleChainConveyorPost = "double-chain-conveyor-post",
  DoubleChainConveyorSideRail = "double-chain-conveyor-side-rail",
  DoubleChainConveyorWheel = "double-chain-conveyor-wheel",
  PalletReciprocatingLiftBase = "pallet-reciprocating-lift-base",
  PalletReciprocatingLiftBottomSideRail = "pallet-reciprocating-lift-bottom-side-rail",
  PalletReciprocatingLiftLayerBeam = "pallet-reciprocating-lift-layer-beam",
  PalletReciprocatingLiftMovingAssembly = "pallet-reciprocating-lift-moving-assembly",
  PalletReciprocatingLiftPost = "pallet-reciprocating-lift-post",
  PalletReciprocatingLiftTop = "pallet-reciprocating-lift-top",
  RackPost = "rack-post",
  RollerConveyorCrossbar = "roller-conveyor-crossbar",
  RollerConveyorPost = "roller-conveyor-post",
  RollerConveyorRoller = "roller-conveyor-roller",
  RollerConveyorSideRail = "roller-conveyor-side-rail",
  RollerLiftTransferCrossbar = "roller-lift-transfer-crossbar",
  RollerLiftTransferRoller = "roller-lift-transfer-roller",
  SideBrace = "side-brace",
  SingleStationReciprocatingShuttleBody = "single-station-reciprocating-shuttle-body",
  SingleStationReciprocatingShuttleRail = "single-station-reciprocating-shuttle-rail",
  SingleStationReciprocatingShuttleTop = "single-station-reciprocating-shuttle-top",
  SteelCoil = "steel-coil",
  WoodenCrate = "wooden-crate"
}

export const allModelAssets = Object.values(ModelAsset);

export const modelAssetUrls: Record<ModelAsset, string> = {
  [ModelAsset.PalletStackerCraneGroundRail]: createModelUrl("托盘堆垛机-地轨.glb"),
  [ModelAsset.PalletStackerCraneBase]: createModelUrl("托盘堆垛机-底部.glb"),
  [ModelAsset.PalletStackerCranePost]: createModelUrl("托盘堆垛机-立柱.glb"),
  [ModelAsset.PalletStackerCraneTop]: createModelUrl("托盘堆垛机-顶部.glb"),
  [ModelAsset.PalletStackerCraneSkyRail]: createModelUrl("托盘堆垛机-天轨.glb"),
  [ModelAsset.PalletStackerCraneCarriage]: createModelUrl("托盘堆垛机-载货台.glb"),
  [ModelAsset.PalletStackerCraneControlCabinet]: createModelUrl("托盘堆垛机-电控箱.glb"),
  [ModelAsset.AngleIron]: createModelUrl("角铁.glb"),
  [ModelAsset.BasePlate]: createModelUrl("底部垫片.glb"),
  [ModelAsset.BinRackBrace]: createModelUrl("料箱货架-加固杆.glb"),
  [ModelAsset.BinCargo]: createModelUrl("货物-料箱.glb"),
  [ModelAsset.BinRackCrossbar]: createModelUrl("料箱货架-横杆.glb"),
  [ModelAsset.BinRackPanel]: createModelUrl("料箱货架-隔板.glb"),
  [ModelAsset.BinRackPost]: createModelUrl("料箱货架-立柱.glb"),
  [ModelAsset.Crossbar]: createModelUrl("横杆.glb"),
  [ModelAsset.DoubleChainConveyorCrossbar]: createModelUrl("双链运输机-横杆.glb"),
  [ModelAsset.DoubleChainConveyorPost]: createModelUrl("双链输送机-立柱.glb"),
  [ModelAsset.DoubleChainConveyorSideRail]: createModelUrl("双链输送机-侧杆.glb"),
  [ModelAsset.DoubleChainConveyorWheel]: createModelUrl("双链运输机-转轮.glb"),
  [ModelAsset.PalletReciprocatingLiftBase]: createModelUrl("托盘往复式提升机-底座.glb"),
  [ModelAsset.PalletReciprocatingLiftBottomSideRail]: createModelUrl(
    "托盘往复式提升机-底侧杆.glb"
  ),
  [ModelAsset.PalletReciprocatingLiftLayerBeam]: createModelUrl("托盘往复式提升机-层铁.glb"),
  [ModelAsset.PalletReciprocatingLiftMovingAssembly]: createModelUrl(
    "托盘往复式提升机-升降部件.glb"
  ),
  [ModelAsset.PalletReciprocatingLiftPost]: createModelUrl("托盘往复式提升机-立柱.glb"),
  [ModelAsset.PalletReciprocatingLiftTop]: createModelUrl("托盘往复式提升机-顶部.glb"),
  [ModelAsset.RackPost]: createModelUrl("立柱.glb"),
  [ModelAsset.RollerConveyorCrossbar]: createModelUrl("辊道输送机-横杆.glb"),
  [ModelAsset.RollerConveyorPost]: createModelUrl("辊道输送机-立柱.glb"),
  [ModelAsset.RollerConveyorRoller]: createModelUrl("辊道输送机-滚轮杆.glb"),
  [ModelAsset.RollerConveyorSideRail]: createModelUrl("辊道输送机-侧杆.glb"),
  [ModelAsset.RollerLiftTransferCrossbar]: createModelUrl("辊道顶升移载-横杆.glb"),
  [ModelAsset.RollerLiftTransferRoller]: createModelUrl("辊道顶升移载-滚轮杆.glb"),
  [ModelAsset.SideBrace]: createModelUrl("加固杆.glb"),
  [ModelAsset.SingleStationReciprocatingShuttleBody]: createModelUrl("单工位往复式穿梭车-车身.glb"),
  [ModelAsset.SingleStationReciprocatingShuttleRail]: createModelUrl("单工位往复式穿梭车-轨道.glb"),
  [ModelAsset.SingleStationReciprocatingShuttleTop]: createModelUrl("单工位往复式穿梭车-顶部.glb"),
  [ModelAsset.SteelCoil]: createModelUrl("货物-托盘卷料.glb"),
  [ModelAsset.WoodenCrate]: createModelUrl("货物-托盘木箱.glb")
};

function createModelUrl(fileName: string) {
  return `/models/${encodeURIComponent(fileName)}`;
}
